<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-row class="searchSection" >
                <el-form ref="form" :inline="true" :key="$route.path" :model="searcheModel" class="demo-form-inline">
                    <el-form-item label="产品筛选">
                        <Product ref="Product" :product_id="searcheModel.product_id"
                        @change="productChange"></Product>
                    </el-form-item>
                    <el-form-item label="客户名称" class="customer-input" >
                        <CustomerSelect ref="CustomerSelect" :customerIdss="searcheModel.customer_name" v-model="searcheModel.customer_name" @change="CustomerHandleChange"></CustomerSelect>
                    </el-form-item>
                    <el-form-item label="所在地区">
                        <DistrictCascader ref="DistrictCascader" @change="changeDistrict" style="width: 100%;"></DistrictCascader>
                    </el-form-item>
                    <el-form-item label="订单负责人">
                        <UserSelect :name="searcheModel.user_name" ref="UserSelect" v-model="searcheModel.user_name" @change="salesmanHandleChange"></UserSelect>
                    </el-form-item>
                    <el-form-item label="所属部门">
                        <UserCascader ref="UserCascader" v-model="searcheModel.branch_id" :isBusiness="true" @change="changeBranch"></UserCascader>
                    </el-form-item>
                    <el-form-item label="产品到期时间">
                        <el-date-picker
                                size="small"
                                v-model="searcheModel.product_times"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                align="right">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="是否有断续原因">
                        <el-select size="small"  v-model="searcheModel.is_disruption_memo" placeholder="请选择" >
                            <el-option  value="0" label="全部"></el-option>
                            <el-option  value="1" label="是"></el-option>
                            <el-option  value="2" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="断续原因">
                        <el-input size="small"  v-model="searcheModel.memo" placeholder="请输入关键词" >
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索</el-button>
                        <el-button size="small" @click="resetForm()">重置</el-button>
                        <ExportFile v-if="Acs('/export/customer-disruption')" url="/api/export/customer-disruption" :params="searcheModel" filename="断续产品数据表">导出</ExportFile>
                    </el-form-item>
                </el-form>
            </el-row>

            <el-table :data="list" class="tabTopBorder" v-loading="loading">
                <el-table-column prop="product_name" label="断续产品"></el-table-column>
                <el-table-column prop="customer_name" label="客户名称"></el-table-column>
                <el-table-column label="所在地区">
                    <template slot-scope="scope">
                        <span v-if="scope.row.customers && scope.row.customers.district_names">{{scope.row.customers.district_names }}</span>
                        <span v-else-if="scope.row.customer">{{ scope.row.customer.district_names }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="customer_level" label="级别" width="70"></el-table-column>
                <el-table-column prop="customer_user_name" label="客户绑定人"></el-table-column>
                <el-table-column label="产品合同时间" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.start_at_fomat}} ~ {{scope.row.end_at_fomat}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="断续原因" width="250"></el-table-column>
                <el-table-column label="订单ID" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)">
                            {{ scope.row.order_id }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="branch_name" label="所在部门"></el-table-column>
                <el-table-column prop="order_user_name" label="订单负责人"></el-table-column>
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </div>
    </div>
</template>

<script>
    import OrderDisruptionService from "~/services/OrderDisruption";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import Product from "~/widgets/Product.vue";
    import UserCascader from "~/widgets/UserCascader.vue";
    import UserSelect from "~/widgets/UserSelect.vue";
    import MyPagination from "~/widgets/MyPagination.vue";
    import ExportFile from "~/widgets/ExportFile.vue";
    import DistrictCascader from "~/widgets/DistrictCascader.vue";
    export default {
        name: "DisruptionProduct",//断续管理列表
        data() {
            return {
                list: [],
                loading: false,
                // 分页信息
                searcheModel:{
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    customer_name: '',
                    product_id: '',
                    user_name: '',
                    branch_id: '',
                    product_times: [],
                    is_disruption_memo: '',//是否有断续原因1：是 2：否
                    memo: '',//断续原因
                },
                formLabelWidth: '120px',
                // 分页信息
                linkPage: null,
            }
        },
        components: {
            CustomerSelect,
            Product,
            UserCascader,
            UserSelect,
            MyPagination,
            ExportFile,
            DistrictCascader
        },
        props: {
        },
        created: function () {
            this.getList();
        },
        methods: {
            resetForm(){
                this.$refs['CustomerSelect'].reset();
                this.$refs['UserSelect'].reset();
                this.$refs["Product"].reset();
                this.$refs["UserCascader"].reset();
                if (this.$refs["DistrictCascader"]) {
                    this.$refs["DistrictCascader"].reset();
                }
                this.searcheModel = {
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    customer_name: '',
                    product_id: '',
                    user_name: '',
                    branch_id: '',
                    product_times: [],
                    is_disruption_memo: '',
                    memo: '',
                };
                this.getList();
            },

            changeDistrict(val){
                this.searcheModel.province_id = val[0] || 0;
                this.searcheModel.city_id = val[1] || 0;
                this.searcheModel.district_id = val[2] || 0;
            },

            submitSearch(){
                let params = this.searcheModel;
                params['page'] = 1;
                this.getList(params);
            },

            getList(params) {
                this.loading = true;
                OrderDisruptionService.getList(params).then(res => {
                    if (res && res.data) {
                        this.list = res.data;
                    }
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                }).catch(err => {
                    this.loading = false;
                    console.error(err);
                })
            },

            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searcheModel.customer_name = object.value;
            },

            salesmanHandleChange(object) {
                this.searcheModel.user_name = object.value;
            },
            
            changeBranch(value) {
                if (value.length > 0) {
                    // 取得最后一级部门作为所属部门
                    this.searcheModel.branch_id = value[value.length - 1];
                } else {
                    this.searcheModel.branch_id = "";
                }
            },

            productChange(value) {
                this.searcheModel.product_id = value;
            },

            handleSizeChange(newSize) {
                // 处理每页条目数变化事件
                let params = this.searcheModel;
                params['perPage'] = newSize;
                this.getList(params);
            },

            handleCurrentChange(newPage) {
                let params = this.searcheModel;
                // 处理当前页码变化事件
                params['page'] = newPage;
                this.getList(params);
            },

            handleView(row) {
                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: {id: row.order_id},
                });
                window.open(routeData.href, '_blank');
            }
        }
    }
</script>

<style scoped>
</style>





// WEBPACK FOOTER //
// src/views/customer/DisruptionProduct.vue